import { useInfiniteQuery } from '@tanstack/react-query'

import { listNotifications } from './api'

export const NOTIFICATIONS_FEED_KEY = ['notifications', 'feed'] as const

/** paginated feed for the bell / command-palette notifications section.
 * uses TanStack's infinite query with the keyset cursor returned by
 * the api.
 */
export function useNotifications(opts?: { unreadOnly?: boolean }) {
  const unreadOnly = opts?.unreadOnly ?? false
  return useInfiniteQuery({
    queryKey: [...NOTIFICATIONS_FEED_KEY, { unreadOnly }],
    queryFn: ({ pageParam, signal }) =>
      listNotifications(
        {
          cursor: pageParam,
          limit: 20,
          unreadOnly
        },
        signal
      ),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: last => last.nextCursor ?? undefined,
    staleTime: 30_000,
    retry: false
  })
}
